import { BASE_URL } from "../api_const"

export const SERVICE_ENQUIRY_REQUEST_BASE_URL = BASE_URL + "/service-enquiry"
export const URL_SERVICE_ENQUIRY_REQUEST_CREATE = SERVICE_ENQUIRY_REQUEST_BASE_URL + "/create"
export const URL_SERVICE_ENQUIRY_REQUEST_CREATE_FORM = SERVICE_ENQUIRY_REQUEST_BASE_URL + "/create-form"
export const URL_SERVICE_ENQUIRY_REQUEST_NEW_CREATE_FORM=BASE_URL +"/create/project/capture_interest"
